import { AfterContentInit, Component, ElementRef, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { CommonService, MessagesService, PageService } from 'src/app/services/service.index';
import { FormGroup,  FormBuilder, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { StyleRenderer, lyl,  ThemeRef, ThemeVariables } from '@alyle/ui';
import {ImgCropperConfig,ImgCropperEvent,LyImageCropper,ImgCropperErrorEvent,ImgCropperLoaderConfig,STYLES as CROPPER_STYLES} from '@alyle/ui/image-cropper';
import { LySliderChange } from '@alyle/ui/slider';
import { AuthService } from 'src/app/models/auth/_services/auth.service';

interface userInfo{
  fot_reco: string | any;
  fot_usua: string | any;
  fmt_data: {
    scale: number | any,
    xOrigin: number | any,
    yOrigin: number | any,
    areaWidth: number | any,
    areaHeight: number | any,
  };
  originPosition: {
    x: number | any,
    y: number | any,
  }
}
interface dataUser {
  cod_usua: string,
  nom_usua: string,
  tip_usua: string,
  fec_acti: string,
  fec_expi: string,
  cod_gusu: string,
  est_usua: string,
  ult_entr: string,
  ult_camb: string,
  blo_usua: string,
  usu_mbox: string,
  usu_emai: string,
  cod_empl: string,
  usu_wind: string,
  ver_cump: string,
  ver_foto: string,
  env_cumc: string,
  ord_empc: string,
  cod_lang: string,
  tip_docu: string,
  cod_inte: string,
  ape_empl: string,
  nom_empl: string,
  sex_empl: string,
  fec_naci: string,
  box_mail: string,
  rel_empl: string,
  act_usua: string,
  act_hora: string,
  act_esta: string,
  tip_nomb: string,
  env_proc: string,
  env_nota: string,
  usu_carg: string,
}

const STYLES = (_theme: ThemeVariables, ref: ThemeRef) => {
  ref.renderStyleSheet(CROPPER_STYLES);
  return {
    sliderContainer: lyl `{
      text-align: center
      max-width: 400px
      margin: 14px
    }`,
    cropResult: lyl `{
      border-radius: 50%
    }`
  };
};

@Component({
  selector: 'app-mi-perfil',
  templateUrl: './mi-perfil.component.html',
  styleUrls: ['./mi-perfil.component.scss']
})
export class MiPerfilComponent implements OnInit {
  dataUser: any = {} as dataUser;
  fechaIngreso!: any;
  tip_name = true;
  passwordForm: FormGroup;
  sessionData: any;
  // @ts-ignore
  miPerfilForm: FormGroup;
  showForm2: boolean = false;
  origen: any;
  userInfo: userInfo = {} as userInfo;
  @ViewChild("changePassword") modal: ElementRef | undefined;
  showPassword: boolean | undefined;
  showoldPassword: boolean | undefined;
  
  // componente imagen
  @ViewChild(LyImageCropper) readonly cropper!: LyImageCropper;
  @ViewChildren("_fileInput") _fileInput: any;
  imgLoadedTem: any;
  closeButtonOptions: any;
  popupVisible = false;
  noUser: any = "assets/img/avatars/no-user.png";
  classes = this.sRenderer.renderSheet(STYLES);
  scale: number = 0;
  croppedImage?: string | null = ""
  ready = false;
  minScale: number = 0;
  myConfig: ImgCropperConfig = {
    // autoCrop: true,
    width: 150, // Default `250`
    height: 150, // Default `200`
    type: 'image/png',
    round: true,
    keepAspectRatio: true,
  };
  // fin componente imagen

  //programas recientes 
  listHisotrial:any=[];
  listFavorite:any=[]
  company: any;
  username: any;
  photouser: any;
    constructor(private _commonService: CommonService, 
    private messageService: MessagesService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private domSanitizer: DomSanitizer,
    readonly sRenderer: StyleRenderer,
    private pageService: PageService,
    private auth: AuthService,

    ) { 
      this.passwordForm = this.formBuilder.group({
        actual: ['',[Validators.required]],
        nueva: ['',[Validators.required, ]],
        confirma: ['',[Validators.required, ]],
      });
      this.closeButtonOptions = {
        text: 'X',
        stylingMode: 'outlined',
        type: 'normal',
        onClick: () => {
          this.popupVisible = false;
        },
      };
    }
    
  ngOnInit(): void {

    this.sessionData = {...JSON.parse(this._commonService.getItemsessionStorage('sessionData') || '{}')};
    this.company = this.sessionData.selectedCompany.code;
    this.username = this.sessionData.username;


    this.initForm();
    this.getProgramRecent();
    this.getPhotouser();
  }

  getProgramRecent(){
    let list = JSON.parse(sessionStorage.getItem('listHisotrial')+'');
    this.listHisotrial = list && list.length?list:[];
    // this.listFavorite = this.pageService.listFavorite;
    // this.listFavorite = this.listFavorite?this.listFavorite.slice(0,5):[];

  }

 


  
  initForm() {
    this.miPerfilForm = this.formBuilder.group({
      imgUser: ['', Validators.required],
      datosUser: this.formBuilder.group({
        tip_nomb: [''],
        nom_usua: [{value: '', disabled: true}],
        cod_lang: [''],
        ord_empc: [''],
        env_cumc: [''],
        env_proc: [''],
        env_nota: [''],
      }),
    });

   
  }
  active(origen: any){
    if (origen === 'usuar_dataBtn') {
      this.showForm2 = false;
      // @ts-ignore
      document.getElementById("preference_Site").classList.remove("active");
      // @ts-ignore
      document.getElementById('usuar_dataBtn').classList.add('active');
    } else {
      this.showForm2 = true;
      // @ts-ignore
      document.getElementById("usuar_dataBtn").classList.remove("active");
      // @ts-ignore
      document.getElementById('preference_Site').classList.add('active');
    }
  }

  submit() {
    Object.entries(this.miPerfilForm.value.datosUser).forEach(([key, value]) => {
      if(typeof value == 'boolean') {
        key == "tip_nomb" ? value ? this.dataUser[key] = "U" : this.dataUser[key] = "E" : value ? this.dataUser[key] = "S" : this.dataUser[key] = "N";
      } else {
        this.dataUser[key] = value;
      }
    });
    // this.profileService.setDataProfile({data: this.dataUser}).subscribe(e => {
    //   this.messageService.success("Se ha guardado con exito", "Se ha guardado la información exitosamente");
    // })
  }

  changeModal() {
    this.modalService.open(this.modal, { size: 'lg' });
  }

  changePass() {
    if(!this.passwordForm.valid){
      this.messageService.error("Formulario no valido", "¡Todos los campos deben ser diligenciados!");
      return;
    };
    if(this.passwordForm.get('nueva')?.value !== this.passwordForm.get('confirma')?.value){
      this.messageService.error("Las contraseñas no coinciden", "¡Las contraseñas no son iguales!");
      return;
    };
    if(this.passwordForm.get('nueva')?.value == this.passwordForm.get('actual')?.value) {
      this.messageService.error("Error", "¡La nueva contraseña no puede ser la misma a la actual!");
      return;
    }
    Object.keys(this.passwordForm.value).forEach(e => {
      this.passwordForm.value[e] = btoa(this.passwordForm.value[e]);
    });
    
    // this.profileService.setPassword(this.passwordForm.value).subscribe(e => {
    //   this.messageService.success('Contraseña actualizada', "¡Se ha actualizado la contraseña con exito!");
    //   this.sessionData.data.user_info.flags.apikey = e.data;
    //   this._commonService.setItemsessionStorage("sessionData", this.sessionData);
    // }, e => {     
    //   this.messageService.error('Error', e);
    //   this.passwordForm.get('actual')?.setValue("");
    //   this.passwordForm.get('nueva')?.setValue("");
    //   this.passwordForm.get('confirma')?.setValue("");
    // })
  }

  getPhoto() {

  }

  setPhoto() {
 
  }

  getPhotouser(){
    this.auth.getUserPhotoProfile(this.sessionData.username).subscribe(resp=>{
      this.photouser= resp;
      // this.changes.detectChanges();
    });
  }



  getData() {
    // this.profileService.getDataProfile().subscribe(e => {
    //   this.fechaIngreso = new Date(e.data.ult_entr);
    //   this.dataUser = e.data;
    //   this.dataUser.usu_carg = this.sessionData.data.user_info.datageneral.nom_carg;
    //   this.switchValues();
    // })
  }

  switchValues = () => {
    this.setValue("nom_usua");
    this.setValue("cod_lang");
    this.setValue("ord_empc");
    this.setValue("tip_nomb", "U");
    this.changeName();
    this.setValue("env_cumc", "S");
    this.setValue("env_proc", "S");
    this.setValue("env_nota", "S");    
  }

  changeName = () => {
    this.miPerfilForm.value.datosUser.tip_nomb ? this.miPerfilForm.get("datosUser")?.get('nom_usua')?.enable() : this.miPerfilForm.get("datosUser")?.get('nom_usua')?.disable();
  }

  setValue = (prop: string, cond?: string) => {
    if(cond) {
      this.dataUser[prop] == cond ? this.miPerfilForm.get("datosUser")?.get(prop)?.setValue(true) : this.miPerfilForm.get("datosUser")?.get(prop)?.setValue(false);
    } else {
      this.miPerfilForm.get("datosUser")?.get(prop)?.setValue(this.dataUser[prop]);
    }
  }



  onCropped(e: ImgCropperEvent) {  
    this.croppedImage = e.dataURL;
    this.popupVisible = false;
    this.userInfo.fot_reco = this.splitString(e.dataURL);
    this.userInfo.fot_usua = this.splitString(e.originalDataURL);
    this.userInfo.fmt_data = {} as any;
    this.userInfo.fmt_data.areaHeight = e.areaHeight;
    this.userInfo.fmt_data.areaWidth = e.areaWidth;
    this.userInfo.fmt_data.scale = e.scale;
    this.userInfo.fmt_data.xOrigin = e.xOrigin;
    this.userInfo.fmt_data.yOrigin = e.yOrigin;
    if(this.userInfo.originPosition.x !== e.xOrigin || this.userInfo.originPosition.y !== e.yOrigin) {
      this.setPhoto();
    }
  }

  onLoaded(e: ImgCropperEvent) {
    this.imgLoadedTem = e.originalDataURL;    
  }

  onError(e: ImgCropperErrorEvent) {
    console.warn(`'${e.name}' is not a valid image`, e);
  }

  onSliderInput(event: LySliderChange) {
    this.scale = event.value as number;
  }
  // fin: logica para el componene de imagen

  splitString = (string: any) => {
    if(string.includes("base64")){
      return string.split(",")[1];
    } else {
      return string;
    }    
  }
  openProgram(prog:any){
    this.pageService.OpenProgram(prog)

  }
}
